const Fb = (props) => (
  <svg viewBox='0 0 33 32' fill='none' {...props}>
    <path fillRule='evenodd' clipRule='evenodd'
      d='M16.2674 31.8688C25.0187 31.8688 32.113 24.7745 32.113 16.0233C32.113 7.27203 25.0187 0.177734 16.2674 0.177734C7.51617 0.177734 0.421875 7.27203 0.421875 16.0233C0.421875 24.7745 7.51617 31.8688 16.2674 31.8688ZM20.609 13.8019L20.1088 17.1322H17.4799V25.1833C16.9048 25.2756 16.3164 25.3228 15.7171 25.3228C15.1177 25.3228 14.5293 25.2756 13.9542 25.1833V17.1322H11.0895V13.8019H13.9542V11.2637C13.9542 8.37677 15.6377 6.7814 18.2159 6.7814C19.4499 6.7814 20.7412 7.00642 20.7412 7.00642V9.84163H19.3177C17.9162 9.84163 17.4799 10.7305 17.4799 11.6418V13.8019H20.609Z'
      fill='#FFE42B' />
  </svg>
)

export default Fb



// WEBPACK FOOTER //
// ./components/icons/fb.js